import { Component, Input, OnInit } from '@angular/core';
import { RunningDocumentChartService } from './running-document-chart.service';
import {
  GroupDashbordDto,
  ParentData,
} from 'src/app/client-management/parc-management';
import * as Highcharts4 from 'highcharts';
require('highcharts/modules/exporting')(Highcharts4);
require('highcharts/modules/no-data-to-display')(Highcharts4);

if (!Highcharts4.Chart.prototype.addSeriesAsDrilldown) {
  require('highcharts/modules/drilldown')(Highcharts4);
}

import { DateInterval } from 'src/app/shared/model';
import { ToastrService } from 'ngx-toastr';
import { GroupDto } from 'src/app/client-management/data-management';
import { ChartConfigService } from 'src/app/utils/chart/chart-config.service';
@Component({
  selector: 'app-running-document-chart',
  templateUrl: './running-document-chart.component.html',
  styleUrls: ['./running-document-chart.component.css'],
})
export class RunningDocumentChartComponent implements OnInit {
  showModal: boolean = false;
  groupeStatistics: any[] = [];
  RunningDocument: Object = null;
  RunningDocumentModal: Object = null;
  DetailRunningDocument: any[] = [];
  date: DateInterval = new DateInterval();
  endDate: Date = new Date();
  startDate: Date = new Date();
  globalLoading: boolean;
  Years :any[] = [];
  displayCalendar: boolean = false;
  IsByParent = false;
  isByMultipleGroups: boolean = false;
  groupIds: GroupDto[] = [];
  documentinfo_: ParentData;

  dropdownSettings: any;


  @Input()
  groups: GroupDto[] = [];

  @Input() show: boolean = false;

  @Input()
  set depensedata(depensedata: ParentData) {
    this.documentinfo_ = Object.assign(depensedata);
    if (this.documentinfo_) {
      this.getRunningDocumentInfo();
    }
  }

  groupDropdownSettings = {};

  constructor(
    private runningDocumentChartService: RunningDocumentChartService,
    public toastr: ToastrService,
    private chartConfig: ChartConfigService
  ) {
    this.Years = this.getYears();
  }

  ngOnInit() {
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'idGroupe',
      textField: 'nom',
      selectAllText: 'Tout sélectionner',
      unSelectAllText: 'Tout désélectionner',
      itemsShowLimit: 3,
      allowSearchFilter: true
    };
    this.startDate = new Date(new Date().getFullYear(), 0, 1);
    this.endDate = new Date(this.startDate.getFullYear(), 11, 31);
    this.getRunningDocumentInfo();
  }

  getRunningDocumentInfo() {
    if (this.show) {
      if (this.documentinfo_.dateEnd != null) {
        this.date.startDate = this.documentinfo_.datestart;
        this.date.endDate = this.documentinfo_.dateEnd;
        this.IsByParent = this.documentinfo_.IsByParents;
        if (this.IsByParent) this.groupIds = [];
        var groups = this.documentinfo_.groups;
      }
    } else {
      this.date.startDate = this.startDate.getTime();
      this.date.endDate = this.endDate.getTime();
      if (this.IsByParent) this.groupIds = [];
      var groups = this.groupIds.map((g) => g.idGroupe).toString();
    }

    this.runningDocumentChartService
      .getRunningDocumentInfo(this.date, groups, this.IsByParent)
      .subscribe((res) => {

        this.groupeStatistics = res as GroupDashbordDto[];
        this.runningDocumentChart();
      });
  }

  onChange(year :any) {
    if (year != 5) {
      this.displayCalendar = false;
      this.startDate = new Date(new Date().getFullYear() - year, 0, 1);
      this.endDate = new Date(this.startDate.getFullYear(), 11, 31);
      this.getRunningDocumentInfo();
    } else {
      this.displayCalendar = true;
    }
  }

  getYears() {
    return [
      { id: 0, name: 'Année En cours' },
      { id: 1, name: 'Année Antérieure ' },
      { id: 2, name: 'Année -2' },
      { id: 3, name: 'Année -3' },
      { id: 4, name: 'Année -4' },
      { id: 5, name: 'Date Personnaliser' },
    ];
  }

  onValidate() {
    this.getRunningDocumentInfo();
  }

  onChangeByMultipleGroups() {
    if (!this.isByMultipleGroups) {
      this.groupIds = [];
      this.getRunningDocumentInfo();
    }
  }

  onChangeType() {
    this.isByMultipleGroups = false;
    if (!this.displayCalendar) {
      this.getRunningDocumentInfo();
    }
  }

  runningDocumentChart() {
    this.setHighCartsLang();
    var that = this;
    var drilldata :any[] = [];
    var data: { name: string; p: number; y: number; drilldown: string }[] = [];
    var totalCost = 0;
    var groupesName = new Set(
      this.groupeStatistics.map((s) => {
        return s;
      })
    );
    for (var i = 0; i < this.groupeStatistics.length; i++) {
      totalCost += this.groupeStatistics[i].total;
    }
    groupesName.forEach((groupeName) => {
      let percent = (groupeName.total * 100) / totalCost;
      data.push({
        name: groupeName.nom,
        p: percent,
        y: groupeName.total,
        drilldown: groupeName.idGroupe,
      });
    });
    this.RunningDocument = {
      chart: {
        type: 'column',
        height: 360,
        events: {
          drilldown: function (e :any) {
            if (!e.seriesOptions) {
              var vehiculesdata: any[] = [];
              that.runningDocumentChartService
                .getRunningDocumentsBygroupe(
                  e.point.drilldown,
                  that.date,
                  that.IsByParent
                )
                .subscribe((res) => {
                  for (let i = 0; i < res.length; i++) {
                    const result = res.filter(
                      (s) => s.vehiculeId === res[i].vehiculeId
                    );
                    var totalCostsOfEachVeh: number = 0;
                    for (var j = 0; j < result.length; j++) {
                      totalCostsOfEachVeh += result[j].cost;
                    }
                    vehiculesdata.push([
                      'Vehicule : ' + res[i].matricule + '  <br /> ',
                      totalCostsOfEachVeh,
                    ]);
                    drilldata.push({
                      name: e.point.name,
                      id: e.point.drilldown,
                      data: vehiculesdata,
                    });
                  }
                });
            }
          },
        },
      },
      title: {
        text: 'Assurances', // par groupe
        style: {
          fontWeight: 'bold',
        },
      },
      credits: {
        enabled: false,
      },
      xAxis: {
        type: 'category',
        labels: {
          rotation: -45,
          style: {
            color: '#000000',
            fontWeight: 'bold',
            textDecoration: 'underline',
          },
        },
      },
      yAxis: {
        title: {
          text: 'Total Assurances',
        },
      },
      legend: {
        enabled: false,
      },
      plotOptions: {
        series: {
          borderWidth: 0,
          dataLabels: {
            enabled: false,
            format: '{point.y:,.2f} ',
            softThreshold: true,
          },
        },
      },
      tooltip: {
        headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
        pointFormat:
          '<span style="color:{point.color}">{point.name} </span> <b>{point.y:,.2f}</b> <br/>',
      },
      series: [
        {
          name: 'Groupe',
          colorByPoint: true,
          dataLabels: {
            enabled: false,
            format: '{point.y:,.2f}',
          },
          tooltip: {
            pointFormat:
              '<span style="color:{point.color}">{point.name} </span> <b>{point.y:,.2f}</b> <br/>' +
              '<b>{point.p:.1f}%</b>',
          },
          data: data,
        },
        {
          type: 'pie',
          name: 'Tout le parc',
          tooltip: {
            pointFormat:
              '<span style="color:#007bff">Coût total :<b>{point.y:,.2f} DH</b></span>',
          },
          data: [
            {
              name: 'Tout le parc',
              y: totalCost,
              color: '#64e572',
            },
          ],
          center: [100, 30],
          size: 70,
          showInLegend: false,
          dataLabels: {
            enabled: false,
          },
        },
      ],
      drilldown: {
        activeAxisLabelStyle: {
          color: '#000000',
          fontSize: '11px',
          fontWeight: 'bold',
        },
        series: drilldata,
      },
    };
    this.RunningDocumentModal = {
      chart: {
        type: 'column',
        events: {
          drilldown: function (e :any) {
            if (!e.seriesOptions) {
              var vehiculesdata: any[] = [];
              that.runningDocumentChartService
                .getRunningDocumentsBygroupe(
                  e.point.drilldown,
                  that.date,
                  that.IsByParent
                )
                .subscribe((res) => {
                  for (let i = 0; i < res.length; i++) {
                    const result = res.filter(
                      (s) => s.vehiculeId === res[i].vehiculeId
                    );
                    var totalCostsOfEachVeh: number = 0;
                    for (var j = 0; j < result.length; j++) {
                      totalCostsOfEachVeh += result[j].cost;
                    }
                    vehiculesdata.push([
                      'Vehicule : ' + res[i].matricule + '  <br /> ',
                      totalCostsOfEachVeh,
                    ]);
                    drilldata.push({
                      name: e.point.name,
                      id: e.point.drilldown,
                      data: vehiculesdata,
                    });
                  }
                });
            }
          },
        },
      },
      title: {
        text: 'Assurances', // par groupe
        style: {
          fontWeight: 'bold',
        },
      },
      credits: {
        enabled: false,
      },
      xAxis: {
        type: 'category',
        labels: {
          rotation: -45,
          style: {
            color: '#000000',
            fontWeight: 'bold',
            textDecoration: 'underline',
          },
        },
      },
      yAxis: {
        title: {
          text: 'Total Assurances',
        },
      },
      legend: {
        enabled: false,
      },
      plotOptions: {
        series: {
          borderWidth: 0,
          dataLabels: {
            enabled: false,
            format: '{point.y:,.2f} ',
            softThreshold: true,
          },
        },
      },
      tooltip: {
        headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
        pointFormat:
          '<span style="color:{point.color}">{point.name} </span> <b>{point.y:,.2f}</b> <br/>',
      },
      series: [
        {
          name: 'Groupe',
          colorByPoint: true,
          dataLabels: {
            enabled: false,
            format: '{point.y:,.2f}',
          },
          tooltip: {
            pointFormat:
              '<span style="color:{point.color}">{point.name} </span> <b>{point.y:,.2f}</b> <br/>' +
              '<b>{point.p:.1f}%</b>',
          },
          data: data,
        },
        {
          type: 'pie',
          name: 'Tout le parc',
          tooltip: {
            pointFormat:
              '<span style="color:#007bff">Coût total :<b>{point.y:,.2f} DH</b></span>',
          },
          data: [
            {
              name: 'Tout le parc',
              y: totalCost,
              color: '#64e572',
            },
          ],
          center: [100, 30],
          size: 70,
          showInLegend: false,
          dataLabels: {
            enabled: false,
          },
        },
      ],
      drilldown: {
        activeAxisLabelStyle: {
          color: '#000000',
          fontSize: '11px',
          fontWeight: 'bold',
        },
        series: drilldata,
      },
    };
    Highcharts4.chart('running', this.RunningDocument);
    Highcharts4.chart('runningModal', this.RunningDocumentModal);
  }

  openModal() {
    this.showModal = true;
  }

  closeModal() {
    this.showModal = false;
  }

  // function for set lang hightcarts
  setHighCartsLang() {
    Highcharts4.setOptions({
      colors: [
        '#35a9e7',
        '#e77e22',
        '#3ea6dc',
        '#47a4d2',
        '#51a2c7',
        '#5a9fbd',
        '#639db3',
        '#6d9ba8',
        '#76999e',
        '#7f9694',
        '#899489',
        '#92927f',
        '#9c9074',
        '#a58d6a',
        '#ae8b60',
        '#b88955',
        '#c1874b',
        '#ca8441',
        '#d48236',
        '#dd802c',
        '#e77e22',
      ],
      // colors: ['#9b20d9', '#9215ac', '#861ec9', '#7a17e6', '#7010f9', '#691af3',
      // '#6225ed', '#5b30e7', '#533be1', '#4c46db', '#4551d5', '#3e5ccf',
      // '#3667c9', '#2f72c3', '#277dbd', '#1f88b7', '#1693b1', '#0a9eaa',
      // '#03c69b',  '#00f194'],
      //colors: ['#007bff', '#66B92E', '#DA932C', '#D65B4A', '#24CBE5', '#64E572', '#FF9655', '#000000', '#6AF9C4', '#f39c12', '#D81B60', '#605ca8', '#3D9970', '#001F3F', '#00c0ef', ' #451e3e', '#adcbe3', '#f37736', '#854442', '#3d1e6d', '#c68642'],
      lang: {
        printChart: 'Imprimer',
        decimalPoint: ',',
        thousandsSep: ' ',
        months: [
          'Janvier',
          'Février',
          'Mars',
          'Avril',
          'Mai',
          'Juin',
          'Juillet',
          'Août',
          'Septembre',
          'Octobre',
          'Novembre',
          'Décembre',
        ],
        weekdays: [
          'Dimanche',
          'Lundi',
          'Mardi',
          'Mercredi',
          'Jeudi',
          'Vendredi',
          'Samedi',
        ],
        shortMonths: [
          'Jan',
          'Fév',
          'Mars',
          'Avr',
          'Mai',
          'Jui',
          'Juil',
          'Août',
          'Sept',
          'Oct',
          'Nov',
          'Déc',
        ],
        downloadPNG: 'Télécharger image PNG',
        downloadJPEG: 'Télécharger image JPEG',
        downloadPDF: 'Télécharger image PDF',
        downloadSVG: 'Télécharger image SVG',
        noData: "Aucune donnée n'est disponible",
      },
    });
  }

  /**
   * Action change date début
   */
  onChangeStartDate() {
    if (this.endDate < this.startDate) {
      this.endDate = null;
    }
  }

}
